<template>
  <div class="devices-card">
    <div class="top">
      <h2>{{$t('home.devices.title')}}</h2>
    </div>
    <div class="bottom">
      <table>
        <tr class="head">
          <th class="status">{{$t('home.devices.status')}}</th>
          <th>{{$t('home.devices.name')}}</th>
          <th>{{$t('home.devices.IP')}}</th>
          <th>{{$t('home.devices.MAC')}}</th>
          <th>{{$t('home.devices.lastActivity')}}</th>
        </tr>
        <tr :key="device.id" class="row" v-for="device in devices">
          <td class="status">
            <font-awesome-icon class="active" icon="check-circle" size="lg" v-if="device.active"/>
            <font-awesome-icon class="disabled" icon="times-circle" size="lg" v-else/>
          </td>
          <td> {{device.name}}</td>
          <td>{{device.ipAddress}}</td>
          <td>{{device.cameraMacAddress}}</td>
          <td>{{device.lastActivation}}</td>
          <!--   <td>{{device.lastActive}}</td>-->
        </tr>
      </table>
    </div>
  </div>

</template>

<script>


export default {
  name: 'DevicesCard',
  computed: {},
  props: {
    devices: {
      type: Array,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .devices-card {
    background: white;
    border-radius: 5px;
    box-shadow: 0 5px 6px 0 #00000026;
  }

  h2 {
    /* color: #878a94; */
    font-size: rem(18px);
    font-weight: 800;
    text-transform: uppercase;
    text-align: left;
    padding: 29px 26px;
    margin: 0;
  }

  .head {
    th {
      border-bottom: 1px solid #005fab;
      padding: 21px;
      /* color: #878a94; */
      &.status {
        width: 45px;
      }
    }

  }

  table {
    border-collapse: collapse;
    width: 100%;
    box-sizing: border-box;
    // // color: $baseTextColor;
    font-size: rem(14px);
    table-layout: fixed;
  }

  .bottom {
    width: 100%;
    padding: 31px;
    box-sizing: border-box;
    overflow-x: scroll;
  }

  .top {
    border-bottom: 1px solid #e5e5e5;
  }

  tr {
    border-bottom: 1px solid #e5e5e5;

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    padding: 10px;

    &:not(:first-child) {
      border-left: 1px solid #e5e5e5;
    }

    &.status {
      text-align: center;
    }
  }

  .active {
    color: $peacock-blue;
  }

  .disabled {
    color: $marine-blue;
  }
</style>
